import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {UserDomainSummaryDTO} from 'ngx-heka-design-lib';
import {MatIcon} from "@angular/material/icon";
import {NgxAuthUtilLibModule} from "ngx-auth-util-lib";

@Component({
  selector: 'app-multi-domain-invitation',
  imports: [CommonModule, MatButton, TranslateModule, MatIcon, NgxAuthUtilLibModule],
  templateUrl: './multi-domain-invitation.component.html',
  standalone: true,
  styleUrl: './multi-domain-invitation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiDomainInvitationComponent {
 
  invitation = input.required<UserDomainSummaryDTO>();
  onAcceptInvitation = output<string>();
  onRejectInvitation = output<string>();
}
